import { gql } from 'urql';

const GetVlocReviewPage = gql`
  query GetVlocReviewPage($input: VlocReviewPageInput!) {
    vlocReviewPage(input: $input) {
      ... on VlocReviewPageError {
        code
        message
        errorTitle: title
      }
      ... on VlocReviewPageView {
        __typename
        autopayDisclaimer
        autopayTitle
        description
        disclaimer
        id
        isAutoPayEnabled
        payByCheckDisclaimer
        title
        autoPayBottomSheet {
          description
          id
          title
        }
        payByCheckBottomSheet {
          description
          id
          title
        }
        vlocReviewDetailsV2 {
          firstPaymentDue
          id
          terms
          fee {
            amount
            currency
            formatted
            formattedWithPlusPrefix
          }
          paymentAmount {
            amount
            currency
            formatted
            formattedWithPlusPrefix
          }
          paymentSchedule {
            id
            installmentState
            title
            amount {
              amount
              currency
              formatted
              formattedWithPlusPrefix
            }
          }
          totalAmount {
            amount
            currency
            formatted
            formattedWithPlusPrefix
          }
          vlocAmount {
            amount
            currency
            formatted
            formattedWithPlusPrefix
          }
        }
      }
    }
  }
`;

export default GetVlocReviewPage;
